import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { isEmpty } from 'lodash';

@Pipe({ name: 'style', })
export class StylePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) { }

  public transform(value: any): object | null {
    if (isEmpty(value)) {
      return null;
    }

    return value;
  }
}
